import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    // Linc Staff Access Roles
    { value: 'lincstaff:learnermerge', label: 'Learner Merge' },
    { value: 'lincstaff:caregivermerge', label: 'Caregiver Merge' },
    { value: 'lincstaff:restrictedimport', label: 'Restricted Import' },
    { value: 'lincstaff:apiactivation', label: 'API Activation' },
    {
      value: 'lincstaff:demopersonmanagement',
      label: 'Demo Person Management',
    },
    { value: 'lincstaff:experimentalfeatures', label: 'Experimental Features' },
    // Admin site roles
    { value: 'adminsite:fullaccess', label: 'Full Access' },
    { value: 'adminsite:manage', label: 'Hero Management' },
    {
      value: 'adminsite:communication',
      label: 'Hero Communication',
    },
    { value: 'adminsite:shmanage', label: 'SuperHero Management' },
  ],
});
